import { ImageEditorTool } from './ImageEditorTool';

/**
 * ImageResizeTool - Resize images to specific dimensions
 * Extends ImageEditorTool with resize-specific functionality
 */
export class ImageResizeTool extends ImageEditorTool {
  constructor() {
    super('resize');
  }

  async init(): Promise<void> {
    await super.init();
    console.log('Image Resize Tool initialized');
  }

  getToolName(): string {
    return 'Image Resize';
  }
}

// Initialize the tool
const tool = new ImageResizeTool();
tool.init();
